/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { makeStyles } from '@material-ui/core/styles';

export const useLinkStyles = makeStyles((theme) => {
  return {
    link: {
      color: `${theme.palette.linkColour}`,
      '&:hover': {
        textDecoration: 'underline',
        color: `${theme.palette.buttonTextHover} !important`,
      },
      '&[data-focustype="key"]': {
        outline: `calc(2rem / 16) solid ${theme.palette.focus}`,
        textDecoration: 'underline',
      },
    },
  };
});
